import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Button from '../Button';

const LinkButton = (props) => <Button tag={Link} {...props} />;

LinkButton.propTypes = {
    ...Button.propTypes,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    children: PropTypes.any,
};

export default LinkButton;
